export default "__VITE_ASSET__HQ_SYfDe__"